let componentsData: any;

try {
  componentsData = require('../../../../dist/components_json.json');
} catch (error) {
  console.warn('components_json.json non trouvé. Utilisation de valeurs par défaut.');
  componentsData = {};
}

import { Meta, StoryFn } from '@storybook/web-components';
import { withComponentControls, toKebabCase } from '@utils/utils';

const elementTag = 'spw-button';

const argTypes = withComponentControls(componentsData, { tag: elementTag });

const meta: Meta = {
  title: 'Composants/Bouton',
  component: elementTag,
  argTypes,
  tags: ['autodocs'],
  parameters: {
    docs: {
      description: {
        component: `
Le bouton est un élément d’interaction avec l’interface permettant à l’utilisateur d’effectuer une action.

[<spw-link>Consulter la documentation</spw-link>](https://zeroheight.com/2310c7a1e/p/9055b6-bouton)
        `,
      },
    },
  },
};

export default meta;

function htmlContent(slot) {
  return /* HTML */ `${slot}`;
}

const Template: StoryFn = args => {
  const element = document.createElement(elementTag);
  const hasSlot = true;
  const slottedLabel = 'label';

  Object.entries(args).forEach(([key, val]) => {
    if (key.startsWith('on')) {
      element.addEventListener(key.substring(2).toLowerCase(), val);
    } else {
      if (key !== slottedLabel) {
        element.setAttribute(toKebabCase(key), val as string);
      }
    }
  });

  if (hasSlot) {
    element.innerHTML = htmlContent(args[slottedLabel]);
  }

  return element;
};

export const Primary = Template.bind({});
Primary.args = {
  variant: 'primary',
  label: 'Primary Button',
};

export const Secondary = Template.bind({});
Secondary.args = {
  variant: 'secondary',
  label: 'Secondary Button',
};

export const Tertiary = Template.bind({});
Tertiary.args = {
  variant: 'tertiary',
  label: 'Tertiary Button',
};

export const WithIcon = Template.bind({});
WithIcon.args = {
  variant: 'primary',
  label: 'Button with icon',
  icon: 'fa-arrow-right',
  iconPosition: 'right',
};
